<!--商务合作-->
<template>
  <div class="business-cooperation-container">
    <header-index/>
    <div class="business-cooperation-content">
      <div class="business-cooperation-top">
        <div class="bigger-li">
          <p>商务合作</p>
          <div class="small-li"><span>留下您的联系方式，我们的服务顾问将为您服务</span></div>
        </div>
      </div>
      <div class="business-cooperation-form" :style="'min-height:'+min_height+'px;'">
        <el-form :model="businessCooperationForm" :rules="rules" ref="businessCooperationForm0" hide-required-asterisk
                 :inline="true" class="demo-form-inline businessCooperationForm">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="businessCooperationForm.name" clearable/>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="businessCooperationForm.companyName" clearable/>
          </el-form-item>
        </el-form>
        <el-form :model="businessCooperationForm" :rules="rules" ref="businessCooperationForm1" hide-required-asterisk
                 :inline="true" class="demo-form-inline businessCooperationForm">
          <el-form-item label="手机" prop="phone">
            <el-input v-model="businessCooperationForm.phone" clearable/>
          </el-form-item>
          <el-form-item label="所在城市" prop="address">
            <el-cascader v-model="businessCooperationForm.address" :options="options"
                         :props="{ expandTrigger: 'hover' }" clearable separator="-"/>
          </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: center;padding-top: 60px">
          <el-button @click="submitForm" type="danger">提交</el-button>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import area_Json from '@/static/area2.json';
import {personalBusinessCooperation} from '@/api/systemSetting'
import {isMobile} from "@/common/tools";

export default {
  name: "index",
  components: {Hang, Home_footer, HeaderIndex},
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请填写电话'));
      } else if (!isMobile(value)) {
        callback(new Error('请填写正确的手机号'));
      } else {
        callback();
      }
    }
    return {
      min_height: document.documentElement.clientHeight - 705,
      businessCooperationForm: {
        name: '',
        companyName: '',
        phone: '',
        address: [],
      },
      options: area_Json,
      rules: {
        name: [
          {required: true, message: '请填写姓名', trigger: 'blur'}
        ],
        companyName: [
          {required: true, message: '请填写公司名称', trigger: 'blur'}
        ],
        phone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
        address: [
          {required: true, message: "请选择所在城市", trigger: "change"}
        ]
      },
      cid: 0,
    }
  },
  methods: {
    /*提交申请*/
    submitForm() {
      let can = 0;
      for (let a = 0; a < 2; a++) {
        this.$refs['businessCooperationForm' + a].validate((valid) => {
          if (valid) {
          } else {
            can++;
            return false;
          }
        });
      }
      if (can == 0) {
        let address = '';
        for (let area of this.options) {
          if (area.value == this.businessCooperationForm.address[0]) {
            address = area.label + '-';
            for (let sub of area.children) {
              if (sub.value == this.businessCooperationForm.address[1]) {
                address += sub.label;
              }
            }
          }
        }
        personalBusinessCooperation({
          request: 'form',
          company: this.businessCooperationForm.companyName,
          mobile: this.businessCooperationForm.phone,
          principal: this.businessCooperationForm.name,
          type: 3,
          city: address,
          uid: this.cid
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('提交成功！');
            this.businessCooperationForm = {name: '', companyName: '', phone: '', address: []};
          }
        })
      }
    }
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
}
</script>
<style scoped>
.business-cooperation-container >>> .business-cooperation-content .business-cooperation-form .el-form--inline .el-form-item {
  width: 49%;
}

.business-cooperation-container >>> .business-cooperation-content .business-cooperation-form .el-form--inline .el-form-item__content {
  width: 80%;
}

.business-cooperation-container >>> .business-cooperation-content .business-cooperation-form .el-cascader {
  width: 100%;
}

.business-cooperation-container >>> .business-cooperation-content .business-cooperation-form .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  width: 30%;
  padding: 15px;
}
</style>
<style scoped lang="scss">
.business-cooperation-container {
  background: #ffffff;

  .business-cooperation-content {
    background: white;
    .business-cooperation-top {
      background: url("~@/assets/img/enterprise/businessCooperation.png") no-repeat;
      height: 330px;
      background-size: 100% 100%;
      text-align: center;
      display: flex;
      align-items: center;
      min-width: 76rem;
      padding: 0px 18%;
      justify-content: center;

      .bigger-li {
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        font-weight: 400;
        color: #FFFFFF;
        p{
          margin-block-end: 0px;
          margin-block-start: 0px;
        }
        .small-li {
          color: #FFFFFF;
          font-size: 16px;
        }
      }
    }
    .business-cooperation-form {
      padding: 50px 18%;
      min-width: 76rem;
      background: white;
    }
  }
}
</style>